<div id="expert_hints_wrap" [ngClass]="{'normal':!isExcellent,'excellent':isExcellent}">
  <div id="experts_hints_picture" [ngClass]="{'normal':!isExcellent,'excellent':isExcellent}">

  </div>
    <h1 id="experts_hints_title" [ngClass]="{'normalTitle':!isExcellent,'excellentTitle':isExcellent}" *ngIf="title">
        <span *ngIf="activity" class="fontSize18" style="font-weight: bold">Mindy</span>{{title}}
    </h1>
   <section id="experts_hints_content" *ngIf="content">
       <span *ngIf="activity" id="quote_left">“</span>
       {{content}}
       <span *ngIf="activity" id="quote_right">”</span>
   </section>
    <section id="experts_hints_summary" *ngIf="summary">
        {{summary}}
    </section>
</div>


// WEBPACK FOOTER //
// ./src/app/expert-hints/expert-hints.component.html